type IconProps = React.ComponentProps<'svg'>

export function Users01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M9.75 12C10.6714 12 11.4001 11.9999 11.9893 12.04C12.5851 12.0807 13.0933 12.165 13.5674 12.3613C14.7313 12.8434 15.6566 13.7687 16.1387 14.9326C16.335 15.4067 16.4193 15.9149 16.46 16.5107C16.5001 17.1 16.5 17.8286 16.5 18.75C16.5 19.1642 16.1642 19.5 15.75 19.5C15.3358 19.5 15 19.1642 15 18.75C15 17.8079 14.9998 17.1387 14.9639 16.6123C14.9284 16.0927 14.861 15.7668 14.7529 15.5059C14.4231 14.7097 13.7903 14.0769 12.9941 13.7471C12.7332 13.639 12.4073 13.5716 11.8877 13.5361C11.3613 13.5002 10.6921 13.5 9.75 13.5H6.75C5.80786 13.5 5.13868 13.5002 4.6123 13.5361C4.09273 13.5716 3.76676 13.639 3.50586 13.7471C2.70971 14.0769 2.07692 14.7097 1.74707 15.5059C1.639 15.7668 1.57159 16.0927 1.53613 16.6123C1.50022 17.1387 1.5 17.8079 1.5 18.75C1.5 19.1642 1.16421 19.5 0.75 19.5C0.335786 19.5 6.62728e-09 19.1642 6.62728e-09 18.75C6.62728e-09 17.8286 -0.000139445 17.1 0.0400391 16.5107C0.0806934 15.9149 0.165042 15.4067 0.361328 14.9326C0.843424 13.7687 1.76873 12.8434 2.93262 12.3613C3.40666 12.165 3.91489 12.0807 4.51074 12.04C5.09995 11.9999 5.82859 12 6.75 12H9.75Z"
          fill="currentColor"
        />
        <path
          d="M17.0234 12.6895C17.1266 12.2885 17.5355 12.0465 17.9365 12.1494C19.9851 12.6767 21.5 14.5357 21.5 16.75V18.75C21.5 19.1642 21.1642 19.5 20.75 19.5C20.3358 19.5 20 19.1642 20 18.75V16.75C20 15.2368 18.9652 13.9635 17.5635 13.6025C17.1625 13.4993 16.9205 13.0905 17.0234 12.6895Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.25 0C10.8734 0 13 2.12665 13 4.75C13 7.37335 10.8734 9.5 8.25 9.5C5.62665 9.5 3.5 7.37335 3.5 4.75C3.5 2.12665 5.62665 0 8.25 0ZM8.25 1.5C6.45507 1.5 5 2.95507 5 4.75C5 6.54493 6.45507 8 8.25 8C10.0449 8 11.5 6.54493 11.5 4.75C11.5 2.95507 10.0449 1.5 8.25 1.5Z"
          fill="currentColor"
        />
        <path
          d="M13.5547 0.759766C13.7101 0.375844 14.1473 0.190347 14.5313 0.345703C16.2706 1.04979 17.5 2.75538 17.5 4.75C17.5 6.74462 16.2706 8.45021 14.5313 9.1543C14.1473 9.30965 13.7101 9.12416 13.5547 8.74023C13.3996 8.35638 13.5849 7.91904 13.9688 7.76367C15.161 7.28092 16 6.11265 16 4.75C16 3.38735 15.161 2.21908 13.9688 1.73633C13.5849 1.58096 13.3996 1.14362 13.5547 0.759766Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
